module.exports = __webpack_public_path__ + "img/layers-blue.b97287bd.png";